import { render } from "./AuthScreenHello.vue?vue&type=template&id=7b79776a&scoped=true"
import script from "./AuthScreenHello.vue?vue&type=script&lang=js"
export * from "./AuthScreenHello.vue?vue&type=script&lang=js"

import "./AuthScreenHello.vue?vue&type=style&index=0&id=7b79776a&scoped=true&lang=less"

import exportComponent from "/home/digital_profile_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b79776a"]])

export default __exports__